<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — CONTACT PAGE
     ════════════════════════════════════════════════ -->
<app-header-style-two></app-header-style-two>

<!-- Page Banner -->
<div class="page-title-area"
     [ngStyle]="{'background-image': 'url(' + createImgPath(contactImg) + ')'}">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li>{{"MENU.Contact" | translate}}</li>
        <li><a routerLink="/">{{"MENU.Home" | translate}}</a></li>
      </ul>
    </div>
  </div>
</div>

<!-- Contact Info Cards -->
<section class="contact-info-area">
  <div class="container">
    <div class="vfu-contact-info">

      <!-- Email -->
      <div class="vfu-contact-box">
        <div class="icon-wrap">
          <i class='bx bx-envelope'></i>
        </div>
        <h3>{{"MENU.Email" | translate}}</h3>
        <p><a href="mailto:{{email}}">{{email}}</a></p>
      </div>

      <!-- Location -->
      <div class="vfu-contact-box">
        <div class="icon-wrap">
          <i class='bx bx-map'></i>
        </div>
        <h3>{{"MENU.Location" | translate}}</h3>
        <p><a href="{{locationMap}}" target="_blank" rel="noopener noreferrer">{{location}}</a></p>
      </div>

      <!-- Phone -->
      <div class="vfu-contact-box">
        <div class="icon-wrap">
          <i class='bx bx-phone-call'></i>
        </div>
        <h3>{{"MENU.CallUs" | translate}}</h3>
        <p><a href="tel:{{phone}}">{{phone}}</a></p>
      </div>

    </div>
  </div>
</section>

<!-- Contact Form -->
<section class="contact-area">
  <div class="container" style="position: relative; z-index: 1;">
    <div class="section-title" style="margin-bottom: 2rem;">
      <span class="sub-title">{{"MENU.ContactUs" | translate}}</span>
      <h2>تواصل معنا</h2>
    </div>

    <div class="vfu-contact-form-wrap" style="max-width: 860px; margin: 0 auto;">
      <form [formGroup]="formGroup">
        <div class="row">

          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <label class="form-label">{{"MENU.Name" | translate}}</label>
              <input class="form-control"
                     formControlName="name"
                     type="text"
                     placeholder="{{'MENU.Name' | translate}}">
              <div class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                {{"MENU.Required" | translate}}
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <label class="form-label">{{"MENU.Phone" | translate}}</label>
              <input class="form-control"
                     formControlName="phone"
                     type="tel"
                     placeholder="{{'MENU.Phone' | translate}}">
              <div class="invalid-feedback" *ngIf="controlHasError('required', 'phone')">
                {{"MENU.Required" | translate}}
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-12">
            <div class="form-group">
              <label class="form-label">{{"MENU.Email" | translate}}</label>
              <input class="form-control"
                     formControlName="email"
                     type="email"
                     placeholder="{{'MENU.Email' | translate}}">
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="form-label">رسالتك</label>
              <textarea class="form-control"
                        formControlName="message"
                        placeholder="اكتب رسالتك هنا..."></textarea>
            </div>
          </div>

          <div class="col-12" style="text-align: center; margin-top: 0.5rem;">
            <button (click)="create()" type="submit" class="btn btn-primary btn-lg">
              <i class='bx bx-paper-plane'></i>
              {{"MENU.Send" | translate}}
            </button>
          </div>

        </div>
      </form>
    </div>
  </div>

  <!-- Background map watermark -->
  <div class="contact-bg-image" aria-hidden="true">
    <img src="assets/img/map.png" alt="">
  </div>
</section>

